import React from "react";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap";
import API from "../../helpers/endpointservice";
import UserRole from "../../helpers/role";
import axios from "axios";
import $ from "jquery";
import CommonIcon from "../../helpers/icons";
import Toaster from "../../helpers/toaster";
import PaginationComponent from "../../helpers/Pagination";
import LoaderVisible from "../../helpers/loader";
import LoaderFailed from "../../helpers/loaderFailed";
import Select from "react-select";
import { logoutFunction } from "../../custom/logoutFunction";
import { toast } from "react-toastify";
import swal from "sweetalert";


const customStyles = {
    control: (provided) => ({
        ...provided,
        border: "1px solid #D12232"
    })
};
const styles = {
    placeholder: (provided) => ({
        ...provided,
        whiteSpace: "noWrap",
        textOverflow: "ellipsis",
    })
}

class Coursecatalog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userRole: "",
            order: "asc",
            sortBy: "",
            courseProvider: "",
            isSortAscending: true,
            descriptionUrl: false,
            pageNewCount: false,
            currentUser: "",
            isRequestFailed: false,
            isRequestLoader: false,
            postLouQuestion: [],
            louEmptyArray: [],
            height: window.innerHeight,
            isMobile: false,
            isRadioMobile: false,
            isSmallMobile: false,
            iswebMobile: false,
            pageCount: 20,
            currentPage: 1,
            perPage: 20,
            totalCount: 0,
            requestCount: 0,
            userId: 8,
            courseList: [{
                id: 0,
                courseCode: "",
                courseTitle: "",
                courseDuration: "",
                courseDescription: "",
                isCourseDescriptionUrl: false,
                vendorId: 0,
                vendor: [],
                skillTypeId: 0,
                skillType: [],
                category1Id: 0,
                category2Id: 0,
                category1: [],
                category2: [],
                isCertificatePresent: true,
                isAutoapproval: true,
                isTrainingbond: true,
                status: ""
            }],
            searchData: {},
            skillTypeList: [],
            category1List: [],
            category2List: [],
            skillName: [],
            category1Name: [],
            category2Name: [],
            category2IdSearch: 0,
            category1IdSearch: 0,
            skillIdSearch: 0,
            isFieldEmpty: false,
            vendorNameList: [],
            vendorSearch: [],
            isSearch: false,
            newCourse: {
                id: 0,
                courseCode: "",
                courseTitle: "",
                courseDuration: "",
                courseDescription: "",
                isCourseDescriptionUrl: false,
                vendorId: 0,
                vendor: [],
                skillTypeId: 0,
                skillType: [],
                category1Id: 0,
                category2Id: 0,
                category1: [],
                category2: [],
                isCertificatePresent: true,
                isAutoapproval: true,
                isTrainingbond: true,
                status: ""

            },
        };


    }

    componentDidMount() {
        this.state.isRequestLoader = true;
        let user = localStorage.getItem("UserId");
        let userRole = localStorage.getItem("Role").split(",")[0];
        this.state.userId = user;
        this.getCourseList();
        this.getSkillList();
        this.getCategory1List();
        this.getVendorList();
        this.state.currentUser = userRole;
        const intervals = setInterval(() => {
            this.resize();
        }, 10);
        $("body").removeClass("scrollhide");
    }

    getCategory1List = () => {
        axios.get(`${API.GET_CATEGORIES}?type=category1`)
            .then((response) => {
                if (response?.status === 200) {
                    this.state.category1List = response.data?.map((category1) => {
                        return {
                            value: category1.id + "," + category1.name,
                            label: (
                                <>
                                    {/* <img
                                src={VendorNameIcon}
                            /> */}
                                    {/* <CommonIcon className="properties-img-2" fileName="courseCategoryIcon" />{" "}
                                &nbsp; */}
                                    <span>{category1.name}</span>
                                </>
                            ),
                        }
                    })
                }

            })
            .catch((error) => {
                console.log(error);
                this.setState({ isRequestLoader: false, isRequestFailed: true });
                logoutFunction(error?.response?.status);
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    }

    getSkillList = () => {
        axios.get(API.GET_SKILLS_TYPE)
            .then((response) => {
                if (response?.status === 200) {
                    // this.setState({
                    //     skillTypeList: response.data
                    // })
                    this.state.skillTypeList = response?.data?.map((skill) => {

                        return {
                            value: skill.id + "," + skill.skillName,
                            label: (
                                <>
                                    {/* <img
                                src={VendorNameIcon}
                            /> */}
                                    {/* <CommonIcon className="properties-img-2" fileName="skillIcon" /> */}


                                    {/* &nbsp; */}
                                    <span>{skill.skillName}</span>
                                </>
                            ),
                        }
                    })
                }

            })
            .catch((error) => {
                console.log(error);
                this.setState({ isRequestLoader: false, isRequestFailed: true });
                logoutFunction(error?.response?.status);
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    }

    fetchPaginationList = (currentPage, perPage) => {
        this.state.isRequestLoader = true;
        this.setState(
            {
                currentPage: currentPage,
                perPage: perPage,
            },
            () => {
                this.getCourseList();
            }
        );
    };

    openCourseCategory = () => {
        let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("courseCatalogueScreen"));
        myOffcanvas.show();
        $("body").addClass("scrollhide")
    };

    resize = () => {
        if (window.innerWidth < 850) {
            this.state.isMobile = true;
        } else {
            this.state.isMobile = false;
        }
        if (window.innerWidth < 750) {
            this.state.isSmallMobile = true;
        } else {
            this.state.isSmallMobile = false;
        }
        if (window.innerWidth < 490) {
            this.state.isRadioMobile = true;
        } else {
            this.state.isRadioMobile = false;
        }
        if (window.innerWidth < 400) {
            this.state.iswebMobile = true;
        } else {
            this.state.iswebMobile = false;
        }

        this.state.height = window.innerHeight;
        this.setState({});
    };
    getVendorList = () => {
        axios
            .get(API.GET_VENDOR)
            .then((response) => {
                if (response?.status === 200) {
                    // this.setState({
                    //     vendorNameList: response?.data
                    // })
                    this.state.vendorNameList = response?.data?.map((vendor) => {
                        return {
                            value: vendor.id + "," + vendor.vendorName,
                            label: (
                                <>
                                    {/* <img
                                    src={VendorNameIcon}
                                /> */}
                                    {/* <CommonIcon className="properties-img-2" fileName="VendorNameIcon" /> */}
                                    {/* &nbsp; */}
                                    <span>{vendor.vendorName}</span>
                                </>
                            ),
                        };
                    });
                }
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                console.log(error);
                this.setState({ isRequestLoader: false, isRequestFailed: true });
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    };

    getCourseList = () => {
        const { currentPage, perPage } = this.state;
        let apiUrl = `${API.GET_COURSE_CATALOGUE}?sortBy=${this.state.sortBy}&isSortAscending=${this.state.order == "asc" ? true : false}&pageNumber=${currentPage}&pagesize=${perPage}`;

        this.setState({ isRequestFailed: false, perPage: perPage });
        axios({
            method: "POST",
            url: apiUrl,
            data: this.state.searchData
        })
            .then((res) => {
                if (res.status === 200) {
                    this.setState({
                        courseList: res.data.values,
                        pageCount: res.data.totalCount,
                        // totalPages: Math.ceil(res.data.totalCount / perPage),
                        isRequestLoader: false,
                        isRequestFailed: false,
                        // sortBy: this.state.sortBy,
                        // order: res.data.order,
                        isSortAscending: this.state.isSortAscending,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                this.state.isRequestFailed = true;
                this.state.isRequestLoader = false;
                this.setState({});
                logoutFunction(error?.response?.status);
                swal("Error!", "Something went wrong. Please try again.", "warning");
                // toast.error("Failed to load.", { position: toast.POSITION.TOP_RIGHT, color: "#fff", })
            });
    };

    showCourse = () => {
        let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("courseCatalogueScreen"));
        myOffcanvas.show();
        $("body").addClass("scrollhide")
        this.setState({ isSearch: false })
    }

    openSearchFilter = () => {
        let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("courseCatalogueScreen"));
        myOffcanvas.show();
        $("body").addClass("scrollhide")
        this.setState({ isSearch: true, isFieldEmpty: false })
    }

    courseDetails = (Id) => {
        this.state.isRequestLoader = true;
        this.setState({})
        let apiUrl = `${API.GET_COURSE_BY_ID}?id=${Id}`;
        axios.get(apiUrl)
            .then((res) => {
                if (res.status === 200) {
                    this.showCourse();
                    this.setState({
                        // newCourse: GetCourseData,
                        newCourse: {
                            id: res.data.id,
                            courseCode: res.data.courseCode,
                            courseTitle: res.data.courseTitle,
                            courseDuration: res.data.courseDuration,
                            courseDescription: res.data.courseDescription,
                            isCourseDescriptionUrl: res.data.isCourseDescriptionUrl,
                            isCertificatePresent: res.data.isCertificatePresent,
                            isAutoapproval: res.data.isAutoapproval,
                            vendorId: res.data.vendorId,
                            skillTypeId: res.data.skillTypeId,
                            category1Id: res.data.category1Id,
                            category2Id: res.data.category2Id,
                            category1: res.data.category1Name,
                            category2: res.data.category2Name,
                            vendor: res.data.vendorName,
                            skillType: res.data.skillType,
                            isTrainingbond: res.data.isTrainingbond,
                            status: res.data.status
                        },
                        isRequestLoader: false,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({ isRequestLoader: false });
                logoutFunction(error?.response?.status);
                swal("Error!", "Something went wrong. Please try again.", "warning");
                // toast.error("Failed to load.", { position: toast.POSITION.TOP_RIGHT, color: "#fff", })
            });

    };

    //Pagination
    handlePageChange = (pageNumber) => {
        this.setState(
            { currentPage: pageNumber },
            () => {
                this.fetchPaginationList(pageNumber, this.state.perPage); //pageSize
            }
        );
    };

    sortTable = (name) => {
        let sortData = this.state.courseList;
        if (sortData.length !== 0) {
            this.state.isRequestLoader = true;
            if (this.state.sortBy === name) {
                this.state.sortBy = name;
                if (this.state.order === "asc") {
                    var ordernew = "desc"
                    this.state.order = ordernew;
                }
                else {
                    var ordernew = "asc"
                    this.state.order = ordernew;
                }
            }
            else {
                this.state.sortBy = name;
                this.state.order = 'asc'
            }
            this.state.pageNewCount = !this.state.pageNewCount;
            this.setState({ currentPage: 1 }, () => {
                this.getCourseList()
            })
            //   this.setState({}, () => {
            // this.getCourseList()
            //   })

        }
    };

    closeProperties = () => {
        $("#courseCatalogueScreen").removeClass("show");
        $("body").removeClass("scrollhide");
        this.state.order = "asc";
        this.setState({
            newCourse: {
                id: 0,
                courseCode: "",
                courseTitle: "",
                courseDuration: "",
                courseDescription: "",
                isCourseDescriptionUrl: false,
                vendorId: 0,
                vendor: [],
                skillTypeId: 0,
                skillType: [],
                category1Id: 0,
                category2Id: 0,
                courseQuestionaireId: 0,
                courseQuestionaire: [],
                category1: [],
                category2: [],
                isCertificatePresent: true,
                isAutoapproval: true,
                status: ""
            },
        })
    }

    handleCategory1 = (selectedOption) => {
        this.category2Rendering(selectedOption);
    };

    handleSkillType = (e) => {
        this.setState({
            skillIdSearch: e ? e.value.split(",")[0] : 0,
            skillName: e
        })
        // this.setState({
        //     newCourse: {
        //         ...this.state.newCourse,
        //         skillType: e,
        //         skillTypeId: e.value.split(",")[0]
        //     }
        // })
    };

    category2Rendering = (selectedOption) => {
        const categoryId = selectedOption ? selectedOption.value.split(",")[0] : 0;

        axios
            .get(`${API.GET_CATEGORIES}?type=category2&category1=${categoryId}`)
            .then((response) => {
                if (response?.status === 200) {
                    const category2Options = response.data?.map((category2) => ({
                        value: category2.id + "," + category2.name,
                        label: (
                            <>
                                {/* <CommonIcon className="properties-img-2" fileName="courseCategoryIcon" />{" "} */}
                                <span>{category2.name}</span>
                            </>
                        ),
                    }));

                    this.setState(() => ({
                        // newCourse: {
                        //     ...prevState.newCourse,
                        //     category1: selectedOption,
                        //     category1Id: categoryId,

                        // },

                        category1IdSearch: categoryId,
                        category1Name: selectedOption,

                        // category1Name: selectedOption,
                        // category1Error: false,
                        // category2Name: prevState.category2Name,
                        category2List: category2Options,
                    }),
                        () => {
                            //Category 2 Value Issue.
                            this.setState({
                                category2Name: "",
                                category2IdSearch: 0
                            })

                        }
                    );
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({ isRequestLoader: false, isRequestFailed: true });
                logoutFunction(error?.response?.status);
                swal("Error!", "Something went wrong. Please try again.", "warning");
                // toast.error("Failed to load.", { position: toast.POSITION.TOP_RIGHT, color: "#fff", })
            });
    }

    handleCategory2 = (e) => {
        this.setState({
            category2IdSearch: e ? e.value.split(",")[0] : 0,
            category2Name: e
        })
        //   this.setState({
        //       newCourse: {
        //           ...this.state.newCourse,
        //           category2: e,
        //           category2Id: e.value.split(",")[0]
        //       }
        //   })
    };

    onChangeCourseCode = (e) => {
        this.state.newCourse.courseCode = e.target.value
        this.setState({})
    }

    onChangeCourseTitle = (e) => {
        this.state.newCourse.courseTitle = e.target.value
        this.setState({})
    }

    onChangeCourseProvider = (e) => {
        this.state.courseProvider = e.target.value
        this.setState({})
    }

    onChangeCourseStatus = (e) => {
        this.state.newCourse.status = e.target.value;
        this.setState({})
    }

    searchCourseCatalogueList = () => {
        if (this.state.newCourse?.courseCode?.trim() !== "" || this.state.newCourse?.courseTitle?.trim() !== "" || this.state.skillIdSearch > 0 || this.state.vendorSearch?.value?.split(",")[1].trim().length > 0 || this.state.category1IdSearch > 0 || this.state.category2IdSearch > 0 || this.state.newCourse?.status?.trim()?.length > 0) {

            this.state.searchData = {
                courseCode: this.state.newCourse.courseCode || null,
                courseTitle: this.state.newCourse.courseTitle || null,
                activeStatus: this.state.newCourse.status || null,
                // courseProvider: this.state.courseProvider || null,
                courseProvider: this.state.vendorSearch?.value?.split(",")[1] || null,
                skills: this.state.skillName?.value?.split(",")[1] || null,
                skillId: this.state.skillIdSearch || 0,
                category1Id: this.state.category1IdSearch || 0,
                category2Id: this.state.category2IdSearch || 0,
                category2Name: this.state.category2Name?.value?.split(",")[1] || null,
                category1Name: this.state.category1Name?.value?.split(",")[1] || null
            }
            this.state.isRequestLoader = true;
            this.state.isSearch = false;
            this.state.isFieldEmpty = false;
            this.state.currentPage = 1;
            this.state.pageNewCount = !this.state.pageNewCount;
            $("#courseCatalogueScreen").removeClass("show");
            $("body").removeClass("scrollhide");
            this.getCourseList();
            this.setState({});
        } else {
            this.state.isFieldEmpty = true;
        }
    }

    closeSearchScreen = () => {
        $("body").removeClass("scrollhide");
        $("#courseCatalogueScreen").removeClass("show");
        this.setState({ isSearch: false });
    }

    clearSearchFields = () => {
        this.state.isRequestLoader = true;
        this.state.searchData = {};
        this.setState({
            skillName: [],
            skillIdSearch: 0,
            vendorSearch: [],
            category1Name: [],
            category1IdSearch: 0,
            category2IdSearch: 0,
            category2Name: [],
            courseProvider: "",
            pageNewCount: !this.state.pageNewCount,
            currentPage: 1,
            newCourse: {
                id: 0,
                courseCode: "",
                courseTitle: "",
                courseDuration: "",
                courseDescription: "",
                isCourseDescriptionUrl: false,
                vendorId: 0,
                vendor: [],
                skillTypeId: 0,
                skillType: [],
                category1Id: 0,
                category2Id: 0,
                courseQuestionaireId: 0,
                courseQuestionaire: [],
                category1: [],
                category2: [],
                isCertificatePresent: true,
                isAutoapproval: true,
                isTrainingbond: true,
                status: ""
            },
        }, () =>
            this.getCourseList()
        );
        this.closeSearchScreen();
    }

    render() {
        const {
            isMobile,
            isRequestFailed,
            isRequestLoader,
            pageCount,
            sortBy,
            order,
            courseList,
            newCourse,
            isSearch,
            iswebMobile,
        } = this.state;
        let {
            menuToggle,
        } = this.props;
        return (
            <>
                <Toaster />
                {$("#courseCatalogueScreen").hasClass("show") ? <div className='viewbar-overlay'></div> : <></>}
                <div
                    className={`${isMobile
                        ? "main-body-mobile" : menuToggle ? "menu-main-body" : "main-body"} `}>

                    <LoaderVisible isLoader={isRequestLoader} />
                    {/* <LoaderFailed isLoader={isRequestFailed} /> */}

                    <div className="w-100 head-fixed-company">
                        {isMobile == true ? (
                            <>
                                <div className="d-flex w-100 mobile-head border-bottom pr-10">
                                    <div className="col-10 mobile-title">Course catalogue</div>
                                    <div className="filter-icon col-2 text-align-end" >
                                        <span className="cursor-pointer" onClick={() => this.openSearchFilter()}>
                                            <CommonIcon fileName="filterIcon" /></span>
                                    </div>
                                </div>
                            </>
                        ) : (<>
                            <div className={` ${menuToggle ? "width-100" : "width-filter"} px-4 position-relative border-bottom row `}>
                                <div className="col-6 border-none title">
                                    <CommonIcon fileName="Coursecatalogueiconactive" /><span className="pl-10 head-span">Course catalogue</span></div>
                                <div className="text-align-end  title border-none display text-16-red mt-3px col-6"><span className="text-20-bold pr-30 cursor-pointer" onClick={() => this.openSearchFilter()}><CommonIcon fileName="filterIcon" /></span></div>
                            </div>
                        </>
                        )}

                    </div>
                    {/* <ToastContainer /> */}
                    <div className={`${isMobile ? "table1-mobile-nodata " : "table3-nodata"} common-table-bottom table-responsive w-100`}>
                    <div className={`table-fixed-header ${isMobile ? "table-scroll-xy-mobile top-105px" : menuToggle ? "table-scroll-xy-menutoggle" : "table-scroll-xy"} table-list-view-bottom`} >
                        <table className={` table fileListTable2 table-borderless table-hover  ${(isMobile ? "" : "")} `}>
                            <thead>
                                <tr>
                                    <td></td>
                                    <td className="cursor-pointer" onClick={() => this.sortTable("courseCode")}>
                                        <span> Course code </span>{sortBy === "courseCode" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />}
                                    </td>
                                    <td className="cursor-pointer" onClick={() => this.sortTable("courseTitle")}>
                                        <span>Course title</span>{sortBy === "courseTitle" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />}
                                    </td>
                                    <td className="cursor-pointer" onClick={() => this.sortTable("vendorName")}>
                                        <span> Course provider</span>{sortBy === "vendorName" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />}
                                    </td>
                                    <td className="cursor-pointer pr-10" onClick={() => this.sortTable("skillName")}>
                                        <span> Skills</span>{sortBy === "skillName" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />}
                                    </td>
                                    <td className="cursor-pointer" onClick={() => this.sortTable("category1Name")}>
                                        <span> Category 1</span>{sortBy === "category1Name" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />}
                                    </td>
                                    <td className="cursor-pointer" onClick={() => this.sortTable("category2Name")}>
                                        <span> Category 2</span>{sortBy === "category2Name" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />}
                                    </td>
                                    {
                                        this.state.currentUser === UserRole.ADMIN &&
                                        <td className="cursor-pointer" onClick={() => this.sortTable("status")}>
                                        <span>Course status</span>{sortBy === "status" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />}
                                    </td>
                                    }
                                    <td className="cursor-pointer" onClick={() => this.sortTable("courseDescription")}>
                                        <span> Course description</span>{sortBy === "courseDescription" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />}
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                {courseList.length !== 0 ? (
                                    courseList.map((item, index) => (
                                        <tr id={"active" + item.id} key={index} className="requestRadioSelect">
                                            <td></td>
                                            <td className="cursor-pointer width-150px" onClick={() => this.courseDetails(item.id)}>
                                                <span><a className="link">{item.courseCode}</a></span>
                                            </td>
                                            <td className="width-150px"><span>{item.courseTitle}{" "}</span></td>
                                            <td className="width-150px"><span>{item.vendorName}</span></td>
                                            <td className="width-150px"><span className="pr-10">{item.skillTypeName}</span></td>
                                            <td className="width-150px"><span>{item.category1Name}</span></td>
                                            <td className="width-150px"><span>{item.category2Name}</span></td>
                                            {
                                                 this.state.currentUser === UserRole.ADMIN &&
                                                 <td><span>{item.status}</span></td>
                                            }
                                            <td className="width-300px">
                                            {item.isCourseDescriptionUrl ? 
                      <a href={item.courseDescription} className="link" target="_blank">{item.courseDescription}</a> :
                                                <span>{item.courseDescription}</span>}
                                                </td>
                                            {/* <td></td> */}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={7} className="table-nodata">
                                            {"No record found"}
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>
                        </div>
                    </div>
                    <div
                        className={`${isMobile ? "common-mobilesubmenu mobile-pagination"
                            : menuToggle ? "common-submenu sidemenu-pagination" : "common-submenu web-pagination"} pb-2 pt-2`}>
                    </div>
                </div>

                {/* View / Edit offcanvas panel  */}
                <div className={` ${"offcanvasStyle"} offcanvas offcanvas-end  `}
                    tabIndex={-1}
                    data-bs-scroll="false"
                    data-bs-backdrop="false"
                    id="courseCatalogueScreen"
                    aria-labelledby="offcanvasScrollingLabel">

                    <>
                        <div
                            className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3 mt-10"}`}>
                            {isSearch == false && <h6 id="offcanvasRightLabel" className="modal-title head-span pr-10 font-weight-bold">
                                {(newCourse.courseCode)}
                            </h6>}
                            {
                                isSearch && <h6 id="offcanvasRightLabel" className="modal-title  head-span font-weight-bold">
                                    Search
                                </h6>
                            }
                            <button
                                className={`text-reset offcavasclose buttonstyle cross-icon-fixed-course-catalogue background-white ${isMobile ? "pr-0" : "pr-0"}`} onClick={() => { isSearch ? this.closeSearchScreen() : this.closeProperties() }}>
                                <CommonIcon fileName="CrossIcon" className="cursor-pointer app-image-hover" />
                            </button>
                        </div>
                        <div className="offcanvas-body px-4 pt-0">
                            {
                                <div >
                                    <div className="row">
                                        <div
                                            className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                            <div className="form-group">
                                                <label
                                                    className={`d-flex m-0 label-text pb-1 ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon className="properties-img-2" fileName="CourseCodeIcon" />
                                                    <span className="pl-5 properties-span-2">Course code</span>
                                                    &nbsp;
                                                </label>
                                                {!isSearch && <label className="label-text">{newCourse.courseCode}</label>}
                                                {isSearch && <input type="text" className="form-control form-text-box my-input-class input-box-masterdata" id="courseTitle" value={newCourse.courseCode} onChange={(e) => this.onChangeCourseCode(e)}
                                                    required />}
                                            </div>
                                        </div>
                                        <div
                                            className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                            <div className="form-group">
                                                <label
                                                    className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon className="properties-img-2" fileName="CourseTitleIcon" />{" "}
                                                    <span className="pl-5 properties-span-2 ">Course title</span>
                                                </label>
                                                {!isSearch && <label className="label-text">{newCourse.courseTitle}</label>}
                                                {isSearch && <input type="text" className="form-control form-text-box my-input-class input-box-masterdata" id="courseTitle" value={newCourse.courseTitle} onChange={(e) => this.onChangeCourseTitle(e)}
                                                    required />}
                                            </div>
                                        </div>
                                        {isSearch &&
                                            // <div
                                            //     className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                            //     <div className="form-group">
                                            //         <label
                                            //             className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""}`}>
                                            //             <CommonIcon className="properties-img-2" fileName="CourseTitleIcon" />{" "}
                                            //             <span className="pl-5 properties-span-2 ">Course provider</span>
                                            //         </label>
                                            //         <input type="text" className="form-control form-text-box my-input-class input-box-masterdata" id="courseTitle" value={this.state.courseProvider} onChange={(e) => this.onChangeCourseProvider(e)}
                                            //             required />
                                            //     </div>
                                            // </div>
                                            <div
                                                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                                <div className="form-group">
                                                    <label
                                                        className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""}`}>
                                                        <CommonIcon
                                                            className="properties-img-2"
                                                            fileName="courseDuration"
                                                        />{" "}
                                                        <span className="pl-7 properties-span-2">Course provider</span>
                                                    </label>
                                                    <Select
                                                        className={`text-12-normal-select my-input-class`}
                                                        classNamePrefix="assigngroups"
                                                        placeholder="Please select an option"
                                                        styles={styles}
                                                        value={this.state.vendorSearch}
                                                        options={this.state.vendorNameList}
                                                        menuPosition="fixed"
                                                        menuPlacement="auto"
                                                        // defaultValue={this.state.selectVendorName || "Select"}
                                                        isClearable={true}
                                                        isMulti={false}
                                                        isSearchable={true}
                                                        onChange={(e) => this.setState({ vendorSearch: e })}
                                                    />

                                                </div>
                                            </div>
                                        }
                                        {!isSearch &&
                                            <div
                                                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                                <div className="form-group">
                                                    <label
                                                        className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""}`}>
                                                        <CommonIcon className="properties-img-2" fileName="VendorNameIcon" />{" "}
                                                        <span className="pl-7 properties-span-2">
                                                            Vendor name
                                                        </span>
                                                    </label>
                                                    {<label className="label-text">{newCourse.vendor}</label>}
                                                    {/* { isSearch &&    <input type="text" className="form-control form-text-box my-input-class input-box-masterdata" id="courseTitle"  placeholder="" 
                                          required />} */}
                                                </div>
                                            </div>
                                        }
                                        {!isSearch &&
                                            <div
                                                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                                <div className="form-group">
                                                    <label
                                                        className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""}`}>
                                                        <CommonIcon className="properties-img-2" fileName="courseDuration" />{" "}
                                                        <span className="pl-5 properties-span-2 ">Course duration</span>
                                                    </label>
                                                    {!isSearch && <label className="label-text">{newCourse.courseDuration}</label>}
                                                    {/* { isSearch &&    <input type="text" className="form-control form-text-box my-input-class input-box-masterdata" id="courseTitle"  placeholder="" 
                                          required />} */}
                                                </div>
                                            </div>
                                        }
                                        <div
                                            className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                            <div className="form-group">
                                                <label
                                                    className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon className="properties-img-2" fileName="skillIcon" />{" "}
                                                    <span className="pl-5 properties-span-2">
                                                    Skills
                                                    </span>
                                                </label>
                                                {!isSearch && <label className="label-text">{newCourse.skillType}</label>}
                                                {isSearch && <Select
                                                    className="text-12-normal-select my-input-class"
                                                    classNamePrefix="assigngroups"
                                                    value={this.state.skillName}
                                                    options={this.state.skillTypeList}
                                                    placeholder="Please select an option"
                                                    styles={styles}
                                                    menuPosition="fixed"
                                                    menuPlacement="auto"
                                                    // defaultValue={this.state.skillTypeDefault}
                                                    isMulti={false}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    // isDisabled = {isSubmitTrue}
                                                    onChange={this.handleSkillType} //ArunPending
                                                />
                                                }

                                            </div>
                                        </div>
                                        <div
                                            className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                            <div className="form-group">
                                                <label
                                                    className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon className="properties-img-2" fileName="courseCategoryIcon" />{" "}
                                                    <span className="pl-7 properties-span-2">
                                                        Category 1
                                                    </span>
                                                </label>
                                                {!isSearch && <label className="label-text">{newCourse.category1}</label>}
                                                {isSearch && <Select
                                                    className="text-12-normal-select my-input-class"
                                                    classNamePrefix="assigngroups"
                                                    value={this.state.category1Name}
                                                    options={this.state.category1List}
                                                    placeholder="Please select an option"
                                                    styles={styles}
                                                    menuPosition="fixed"
                                                    menuPlacement="auto"
                                                    // defaultValue={this.state.category1Default}
                                                    isMulti={false}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    // styles={this.state.category1Error && customStyles}
                                                    // isDisabled = {isSubmitTrue}
                                                    onChange={this.handleCategory1} //ArunPending
                                                />}
                                            </div>
                                        </div>
                                        <div
                                            className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                            <div className="form-group">
                                                <label
                                                    className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon className="properties-img-2" fileName="courseCategoryIcon" />{" "}
                                                    <span className="pl-7 properties-span-2">
                                                        Category 2
                                                    </span>
                                                </label>
                                                {!isSearch && <label className="label-text">{newCourse.category2}</label>}
                                                {isSearch && <Select
                                                    className="text-12-normal-select my-input-class"
                                                    classNamePrefix="assigngroups"
                                                    value={this.state.category2Name}
                                                    options={this.state.category2List}
                                                    placeholder="Please select an option"
                                                    isMulti={false}
                                                    menuPosition="fixed"
                                                    menuPlacement="auto"
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    styles={styles}
                                                    // styles={this.state.category2Error && customStyles}
                                                    onChange={this.handleCategory2} //ArunPending
                                                    isDisabled={!this.state.category1Name}
                                                />}
                                            </div>
                                        </div>
                                        {!isSearch && <div
                                            className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                            <div className="form-group">
                                                <label
                                                    className={`d-flex m-0 label-text flex-column gap-2 ${isMobile ? "pt-2" : ""}`}>
                                                    <div>
                                                        <CommonIcon className="properties-img-2" fileName="certificateCourseCatalogue" />{" "}
                                                        <span className="pl-5 properties-span-2">Certificate</span>
                                                    </div>
                                                    <label className="label-text">{(newCourse.isCertificatePresent == true) ? "Yes" : "No"}</label>
                                                </label>
                                            </div>

                                        </div>}
                                        {!isSearch && <div
                                            className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                            <div className="form-group">
                                                <label
                                                    className={`d-flex m-0 label-text flex-column gap-2 ${isMobile ? "pt-2" : ""}`}>
                                                    <div>
                                                        <CommonIcon className="properties-img-2" fileName="successTick" />{" "}
                                                        <span className="pl-5 properties-span-2">Auto approval</span>
                                                    </div>

                                                    <label className="label-text">{(newCourse.isAutoapproval == true) ? "Yes" : "No"}</label>
                                                </label>

                                            </div>
                                        </div>}
                                        {!isSearch && <div
                                            className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                            <div className="form-group">
                                                <label
                                                    className={`d-flex m-0 label-text flex-column gap-2 ${isMobile ? "pt-2" : ""}`}>
                                                    <div>
                                                        <CommonIcon className="properties-img-2" fileName="trainingbondicon" />
                                                        <span className="pl-5 properties-span-2">Training bond applicable</span>
                                                    </div>

                                                    <label className="label-text">{(newCourse.isTrainingbond == true) ? "Yes" : "No"}</label>
                                                </label>

                                            </div>
                                        </div>}
                                        {
                                            this.state.currentUser === UserRole.ADMIN &&
                                            <>
                                             <div
                                            className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                            <div className="form-group">
                                                <label
                                                    className={`d-flex m-0 label-text flex-column gap-2 ${isMobile ? "pt-2" : ""}`}>
                                                    <div>
                                                        <CommonIcon className="properties-img-2" fileName="MyselfIcon" />
                                                        <span className="pl-5 properties-span-2">Course status</span>
                                                    </div>
                                                    {!isSearch && <label className="label-text">{newCourse?.status ? newCourse.status : "-"}</label>
                                               }
                                                {isSearch && <input type="text" className="form-control form-text-box my-input-class input-box-masterdata" id="courseTitle" value={newCourse.status} onChange={(e) => this.onChangeCourseStatus(e)}
                                                    required />}
                                                    </label>
                                            </div>
                                        </div>
                                            </>
                                        }
                                       
                                        {
                                            this.state.isFieldEmpty && <span className="send-rework-label">
                                                Atleast one field is required
                                            </span>
                                        }
                                        {!isSearch && <div
                                            className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                            <div className="form-group">
                                                <label
                                                    className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon className="properties-img-2" fileName="courseDescIcon" />{" "}
                                                    <span className="pl-5 properties-span-2 ">Course description / URL</span>
                                                </label>
                                                <label className="label-text course-description-width">{this.state.newCourse?.courseDescription}</label>
                                            </div>
                                        </div>}

                                        {isSearch &&
                                            <div className="d-flex col-12 col-sm-12 col-md-12 col-lg-12 mt-3 mb-1">
                                                <button
                                                    className="btn rejectbutton"
                                                    onClick={() => this.clearSearchFields()}
                                                >
                                                    <CommonIcon
                                                        className="button-img"
                                                        fileName="ButtonRejectApprovalIcon"
                                                    />
                                                    <span className="px-1">Clear</span>
                                                </button>
                                                {/* <button className="btn approvebutton mx-2" onClick={() => this.searchCourseMasterList()}><CommonIcon className="button-img" fileName="searchIcon" /><span className="pl-10">Search</span></button> */}
                                                <button
                                                    className={`btn approvebutton d-flex gap-1 mx-2`}
                                                    onClick={() => this.searchCourseCatalogueList()}
                                                >
                                                    <span>
                                                        <CommonIcon fileName="searchableIcon" />
                                                    </span>
                                                    <span className="model-label pl-vendor3 pl-2">Search</span>
                                                </button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>

                    </>

                </div>

                {/* Pagination */}

                <PaginationComponent fetchPagination={this.fetchPaginationList} pageCount={pageCount} reset={this.state.pageNewCount} />
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return { dispatch };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(Coursecatalog)
);






